import { captureException } from "@sentry/browser"
import { tap } from "app/common/utilities/tap"

export const logException = tap(captureException)
